import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=b2f92ad4&"
import script from "./CustomerEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports